import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useState } from "react";
import { Trash2, PenLine } from "lucide-react";
import { Link } from "react-router-dom";
import { TabsContent } from "@/components/ui/tabs";
import { DeleteDialog } from "@/components/dialog/menu-manage/essential-menu/essential-drink-dialog";

const data = [
  {
    name: "Rakib Hasan",
    image: "https://i.pravatar.cc/40?img=1",
    description: "-",
    parentCategory: "Beer",
    nestedCategory: "Beer>Cock",
    viewOrder: "01",
    status: true,
  },
];

function PizzaTopingsDraftListTable() {
  const [deleteDialog, setDeleteDialog] = useState(false);

  const closeDeleteDialog = () => {
    setDeleteDialog(false);
  };

  return (
    <TabsContent className="mt-5" value="draft">
      <Table className="w-full">
        <TableHeader>
          <TableRow>
            <TableHead>Name</TableHead>
            <TableHead>Description</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Price</TableHead>
            <TableHead className="text-right">Action</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {Array(15)
            .fill(data[0])
            .map((person, index) => (
              <TableRow key={index}>
                <TableCell className="font-medium">{person.name}</TableCell>
                <TableCell>{person.description}</TableCell>
                <TableCell>$ 5.00</TableCell>
                <TableCell>
                  {person.status ? (
                    <span className="text-cgreen text-base">Draft</span>
                  ) : (
                    <span className="text-cred">Archived</span>
                  )}
                </TableCell>
                <TableCell className="text-right justify-end flex gap-2 items-center">
                  <div className="flex items-center gap-2 h-8">
                    <Link
                      to={"/backoffice/menu/essentail-menu/pizza/update-troppings"}
                      className="cursor-pointer"
                    >
                      <PenLine className="text-cyellow" size={18} />
                    </Link>

                    <Trash2
                      onClick={() => setDeleteDialog(true)}
                      className="text-cred cursor-pointer"
                      size={18}
                    />
                  </div>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      {/* dialog */}
      <DeleteDialog isOpen={deleteDialog} onClose={closeDeleteDialog} />
    </TabsContent>
  );
}

export default PizzaTopingsDraftListTable;
